import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class PMSViewModel {
    ShowAlert:      (pTitle: string, pMessage: string) => void;
    BackToSignIn:   ()                                 => void;
    ReloadMenu:     ()                                 => void;
    NewLoading:     (pMessage: string)                 => dmLoading;

    mlText:         MLText;
    app:            mlBroker;
    ml:             mlBroker;
    Hotel:          dmHotel;
    LangID:         number;
    Lang:           string;

    ImgUri:         string;

    IsPMSActive:    boolean;
    APIKey:         string;

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pReloadMenu:   ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText          = pMLText;
        this.LangID          = this.mlText.GetLangID();
        this.Lang            = this.mlText.GetLangCode();
        this.app             = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml              = this.mlText.GetBroker(
            'HotelAreaPMS'
        );

        this.Hotel           = pHotel;
        this.BackToSignIn    = pBackToSignIn;
        this.ReloadMenu      = pReloadMenu;
        this.ShowAlert       = pShowAlert;
        this.NewLoading      = pNewLoading;

        this.IsPMSActive     = (this.Hotel.HotelInfo.PMSActive == 1);
        this.APIKey          = this.Hotel.HotelInfo.PMSAPIKey;

        this.ImgUri          = 'https://www.tobook.com/images/ORCA-Channel-Manager-Notifications-'
            + this.Lang
            + '.png';
    }

    public ActivatePMS(): void {
        let loading = this.NewLoading(
            this.app.Text('StartingDownloadMark', 'Starting Download...')
        );

        loading.Show(() => {
            let grantParams = RQParam.OtaGrantOrGetPMSAPIKeyParams();

            grantParams.HotelID = this.Hotel.HotelID;

            RQService.Ota.GrantOrGetPMSAPIKey(grantParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let apiKey = RQService.Ota.PopulateGrantOrGetPMSAPIKeyRow(
                    response.RQueryResult[0]
                );

                this.APIKey                    = apiKey.APIKey;
                this.Hotel.HotelInfo.PMSAPIKey = apiKey.APIKey;
                this.IsPMSActive               = true;
                this.Hotel.HotelInfo.PMSActive = 1;

                loading.Dismiss();

                this.ReloadMenu();

                window.location.href = 'https://www.tobook.com/static/OrcaSetup.zip';
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/pms/xv-pms.ts